module.exports = __webpack_public_path__ + "img/image_th.878403b.png";